export default __webpack_public_path__ + "static/media/ilustracion_login.2849bab0.png";